module.exports = __webpack_public_path__ + "img/apple-app-store_en_equalised.9a874122.svg";